import { useTreatmentDefinition } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, TreatmentEdit } from "@/features/catalog";
import {
  treatmentDefinitionRouteId,
  treatmentDefinitionUrlFromRouteId,
} from "@/features/catalog/lib/treatment-definition-route";

export const Route = createFileRoute("/catalog/treatments/$treatmentId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("ActivityDefinition")) throw redirect({ to: "/catalog/procedures" });
  },
  component: TreatmentEditRoute,
});

function TreatmentEditRoute() {
  const { treatmentId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const definition = useTreatmentDefinition(treatmentDefinitionUrlFromRouteId(treatmentId));
  const back = (url = definition?.url) =>
    url
      ? navigate({ to: "/catalog/treatments/$treatmentId", params: { treatmentId: treatmentDefinitionRouteId(url) } })
      : navigate({ to: "/catalog/procedures" });

  if (!definition) {
    return <CatalogDefinition.NotFound label="Treatment" backTo="/catalog/procedures" backLabel="Back to procedures" />;
  }

  return (
    <TreatmentEdit
      key={definition.url}
      definition={definition}
      canEdit={permissions.canWrite("ActivityDefinition")}
      onDone={back}
      onCancel={() => back()}
    />
  );
}
